//TODO: импорты с верхнего уровня надо организовать через алиасы, чтобы не было таких длинных путей
import { apiRequest } from '../../../shared/api/client';
import {
  delegationChangeRequestActionSchema,
  delegationChainSchema,
  delegationMutationResponseSchema,
  pendingDelegationChangeRequestSchema,
} from './schemas';

export async function fetchDelegationState(token: string) {
  const chain = await apiRequest('/delegation/me/chain', {
    token,
    parse: delegationChainSchema.parse,
  });
  const root = chain.length ? chain[chain.length - 1] : null;

  return { chain, root };
}

export async function requestDelegation(token: string, toUserId: string) {
  await apiRequest('/delegation', {
    method: 'POST',
    token,
    body: { toUserId },
    parse: delegationMutationResponseSchema.parse,
  });
}

export async function requestDelegationRevoke(token: string) {
  await apiRequest('/delegation', {
    method: 'DELETE',
    token,
    parse: delegationMutationResponseSchema.parse,
  });
}

export async function fetchPendingDelegationChangeRequest(token: string) {
  return apiRequest('/delegation/me/change-request', {
    token,
    parse: pendingDelegationChangeRequestSchema.parse,
  });
}

export async function confirmPendingDelegationChangeRequest(token: string) {
  return apiRequest('/delegation/me/change-request/confirm', {
    method: 'POST',
    token,
    parse: delegationChangeRequestActionSchema.parse,
  });
}

export async function cancelPendingDelegationChangeRequest(token: string) {
  return apiRequest('/delegation/me/change-request/cancel', {
    method: 'POST',
    token,
    parse: delegationChangeRequestActionSchema.parse,
  });
}
